export default __webpack_public_path__ + "static/media/Diviner's Gloves of Consumed Souls.c2620972.jpg";